import {Route, Routes, Navigate, useLocation} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {HoteleriaRoutes} from './HoteleriaRoutes'
import {CentralRoutes} from './CentralRoutes'
import {SoFoodRoutes} from './SoFoodRoutes'
import {LavanderiaRoutes} from './LavanderiaRoutes'
import {useEffect} from 'react'
import {useKhipu} from '../khipu/hooks/useKhipu'
import {PanelWrapper} from '../khipu/pages/PanelWrapper'
import {RecreacionRoutes} from './RecreacionRoutes'
import {LimpiezaRoutes} from './LimpiezaRoutes'

const PrivateRoutes = () => {
  const location = useLocation()
  const {setAppId} = useKhipu()

  const APPS = {
    panel: 'Panel',
    central: 'Central',
    hoteleria: 'Hotelería',
    lavanderia: 'Lavandería',
    hospitality: 'Hospitality',
  } as any

  useEffect(() => {
    const splittedPath = location.pathname.split('/')
    const path = splittedPath.length > 1 ? splittedPath[1] : ''
    const appId = APPS[path] || 0
    if (path) {
      setAppId(appId)
    }
  }, [location])

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/panel' />} />
        {/* Pages */}
        <Route path='panel' element={<PanelWrapper />} />
        {/* Central Routes */}
        <Route path='central/*' element={<CentralRoutes />} />
        {/* Hoteleria Routes */}
        <Route path='hoteleria/*' element={<HoteleriaRoutes />} />
        {/* SoFood Routes */}
        <Route path='control-comensales/*' element={<SoFoodRoutes />} />
        {/* Lavanderia Routes */}
        <Route path='lavanderia/*' element={<LavanderiaRoutes />} />
        {/* Recreacion Routes */}
        <Route path='recreacion/*' element={<RecreacionRoutes />} />
        {/* Limpieza Routes */}
        <Route path='hospitality/*' element={<LimpiezaRoutes />} />
        {/* Lazy Modules */}
        {/* <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        /> */}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

// const SuspensedView: FC<WithChildren> = ({children}) => {
//   const baseColor = getCSSVariableValue('--kt-primary')
//   TopBarProgress.config({
//     barColors: {
//       '0': baseColor,
//     },
//     barThickness: 1,
//     shadowBlur: 5,
//   })
//   return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
// }

export {PrivateRoutes}
